import {Component, OnInit, ViewChild, AfterViewChecked, Input, Output, Inject, OnDestroy} from '@angular/core';

declare var $: any;
import * as moment from 'moment';
import {EmployeeService} from '../../../services/employee.service';
import {Resource} from '../../../entities/Resource';
import {Priorities, Statuses, Task} from '../../../entities/Task';
import {TaskService} from '../../../services/task.service';
import {environment} from '../../../../environments/environment';
import {TimeplanService} from '../../../services/timeplan.service';
import {ResourceTaskTime} from '../../../entities/ResourceTaskTime';
import {CalendarService} from '../../../services/calendar.service';
import {Calendar} from '../../../entities/Calendar';
import {ActivatedRoute} from '@angular/router';
import {ConverterService} from '../../../services/converter.service';
import {TaskPageModel, TaskTypes} from '../../../entities/PageModel';
import {Job} from '../../../entities/Job';
import {Observable} from 'rxjs';
import {ConfigService} from '../../../services/config.service';

@Component({
  selector: 'app-full-calendar',
  templateUrl: './full-calendar.component.html',
  styleUrls: ['./full-calendar.component.css']
})
export class FullCalendarComponent implements OnInit, OnDestroy {

  @ViewChild('dumbComp') child;

  calendar: Calendar = null;

  unPlannedTasks: TaskPageModel = null;

  plannedTasks: TaskPageModel = null;

  /*externalTasks: Task[] = null;
  externalCurrentTasks: Task[] = null;
  externalPlannedTasks: Task[] = null;*/

  employees: Resource[];

  chosenEmployee: Resource;

  subscription;

  Priorities = Priorities;

  Statuses = Statuses;

  routeParams: any;

  firstRun: Boolean;

  // Specifiable calendar variables
  defaultView: string;
  calendarDate: string;

  ChosenJob: Job;

  JobTasks: Task[];

  jobSubscription;


  constructor(private employeeService: EmployeeService,
              private taskservice: TaskService,
              private timePlanService: TimeplanService,
              private calendarService: CalendarService,
              private ConvertService: ConverterService,
              private config: ConfigService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.firstRun = true;
    this.route.params.subscribe(params => this.routeParams = params);
    this.chosenEmployee = new Resource();
    const requestedId = this.routeParams['id'];
    this.defaultView = this.routeParams['view'];
    this.calendarDate = this.routeParams['date'];

    if (requestedId != null) {
      const sub = this.employeeService.getAllUsers().subscribe(users => {
        this.employees = users;
        this.chosenEmployee = this.employees.find(x => x.No === requestedId), this.refreshCalendar();
        this.listenForJobNumber();
        sub.unsubscribe();
      });

    } else {
      let sub = this.employeeService.getAllUsers().subscribe(users => {
        this.employees = users;
        this.chosenEmployee = this.employees[0], this.refreshCalendar();
        this.listenForJobNumber();
        sub.unsubscribe();
      });
    }

    //this.taskservice.getUnassignedTasks().subscribe(tasks => {this.externalTasks = tasks; console.log(this.externalTasks)});
  }

  listenForJobNumber() {
    this.jobSubscription = this.config.observableJob.subscribe(x => {

      if (!this.firstRun) {
        //this.taskRef = null;
        //this.calendarTask = null;
        this.plannedTasks.PageIndex = 1;
        this.unPlannedTasks.PageIndex = 1;
        this.refreshCalendar()
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
    }
    if (this.jobSubscription != null) {
      this.jobSubscription.unsubscribe();
    }
  }

  //Call the servies to get fresh data to the calendar.
  refreshCalendar() {
    this.ChosenJob = this.config.chosenJob;
    if (this.ChosenJob != null && this.ChosenJob.No != 'Alle sager') {
      let sub = this.calendarService.getCalendar(this.chosenEmployee.No).subscribe(calendar => {
        this.calendar = this.ConvertService.convertToCalendar(calendar);
        let taskSub = this.taskservice.getTasksFromJob(this.ChosenJob.No).subscribe(tasks => {
          this.JobTasks = tasks.filter(x => moment(x.start).utc().format(environment.FULL_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_FULL && moment(x.end).utc().format(environment.FULL_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_FULL);
          taskSub.unsubscribe()
        });


        this.renderCalendarForSpecificJob();
        this.child.rerenderCalendar(this.calendar);
        sub.unsubscribe();
        this.firstRun = false;
      });

      let t1 = new TaskPageModel();
      t1.Type = TaskTypes.Planned;
      t1.JobNo = this.ChosenJob.No;
      let t2 = new TaskPageModel();
      t2.Type = TaskTypes.UnPlanned;
      t2.JobNo = this.ChosenJob.No;

      if (this.unPlannedTasks != null && this.plannedTasks != null) {
        t1.PageIndex = this.plannedTasks.PageIndex;
        t2.PageIndex = this.unPlannedTasks.PageIndex;
      } else {
        t1.PageIndex = 1;
        t2.PageIndex = 1;
      }

      this.refreshFilteredTasks(t1);
      this.refreshFilteredTasks(t2);
    } else {
      let sub = this.calendarService.getCalendar(this.chosenEmployee.No).subscribe(calendar => {
        this.calendar = this.ConvertService.convertToCalendar(calendar);
        this.child.rerenderCalendar(this.calendar);
        sub.unsubscribe();
      });

      let t1 = new TaskPageModel();
      t1.PageIndex = 1;
      t1.Type = TaskTypes.Planned;
      let t2 = new TaskPageModel();
      t2.PageIndex = 1;
      t2.Type = TaskTypes.UnPlanned;
      this.refreshFilteredTasks(t1);
      this.refreshFilteredTasks(t2);

    }

  }

  refreshFilteredTasks(taskPageModel: TaskPageModel) {
    this.taskservice.getFilteredTasks(taskPageModel).subscribe(pTasks => {
      if (taskPageModel.Type == TaskTypes.Planned) {
        this.plannedTasks = pTasks;
      } else {
        this.unPlannedTasks = pTasks;
      }
      this.changeTaskPage(taskPageModel);
    });
  }

  renderCalendarForSpecificJob() {
    this.calendar.ResourceTaskTimes.forEach(
      x => {
        x.color = x.JobNo != this.ChosenJob.No ? '#DA000D' : '#337ab7';
        x.title = x.JobNo != this.ChosenJob.No ? '' : x.title;
        x.constraint = x.JobNo != this.ChosenJob.No ? '1' : null;
      }
    );
  }

  changeTaskPage(pageModel: TaskPageModel) {
    switch (pageModel.Type) {
      case TaskTypes.Planned:
        this.plannedTasks.PageIndex = pageModel.PageIndex;
        break;
      case TaskTypes.UnPlanned:
        this.unPlannedTasks.PageIndex = pageModel.PageIndex;
        break;
    }
  }

  // Calls the service to save the updated task data, after converting the dateTime.
  updateTask(taskToUpdate: Task) {
    //let updatedTask = {taskGUID: taskDropInfo.taskGUID, Responsible: taskDropInfo.employeeNo, start: taskDropInfo.startDate, end: taskDropInfo.endDate};

    //updatedTask = this.convertToNav(updatedTask)

    this.taskservice.putTaskInfo(taskToUpdate).subscribe();
  }

  updateTimePlan(resourceTaskTime: ResourceTaskTime) {
    this.timePlanService.updateTimePlan(this.ConvertService.ConvertFromSchedulerDate(resourceTaskTime, false)).subscribe(() => {
    });
  }

  removeEmpTimePlan(resourceTaskTime: ResourceTaskTime) {
    this.timePlanService.removeTimePlan(resourceTaskTime).subscribe(() => {
    });
  }

  // Converts the updated task to NAV data.
  // Formats DateTimes and sets the necesarry properties.
  /*convertToNav(updatedTask : any)
  {
    updatedTask.start = moment(updatedTask.start).format(environment.FULL_DATETIME_FORMAT);
    if(updatedTask.end != null) {

      let updatedEndDate = moment(updatedTask.end);
      updatedTask.end = updatedEndDate.format(environment.FULL_DATETIME_FORMAT);

      if (updatedEndDate.format(environment.END_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_END && updatedEndDate.format(environment.START_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_START) {
        updatedTask.end = moment(new Date(updatedTask.end).setDate(new Date(updatedTask.end).getDate() - 1)).format(environment.FULL_DATETIME_FORMAT);
        console.log("Kig her ass" + updatedTask.end);
      }
    }
    else{
      updatedTask.end = moment(environment.DEFAULT_DATETIME_FULL).format(environment.FULL_DATETIME_FORMAT);
    }
    return updatedTask;
  }*/

  // Sets the chosen employee.
  setEmployee(emp: Resource) {
    this.calendar.ResourceTaskTimes = null;
    this.chosenEmployee = emp;
    this.refreshCalendar();
  }

  // Converts the given tasks to the FullCalendar.
  // Formats DateTimes and sets the necesarry properties.
  /*convertToCalendar(resTT : ResourceTaskTime[])
  {
    console.log(this.chosenEmployee);
    console.log(resTT);
      for (let t of resTT) {
        t.title = t.Customer;
        let sdate = moment(t.start);
        let edate = moment(t.end);

        let e = new Date(t.end);

        if (sdate.utc().format(environment.END_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_END) {
          t.start = sdate.utc().format(environment.START_DATETIME_FORMAT);

          // Set the end date one day forward. because the calendar dosent include the last.
          edate = moment(e.setDate(e.getDate() + 1));
          t.end = edate.utc().format(environment.START_DATETIME_FORMAT);
        }
        else {
          t.start = sdate.utc().format(environment.FULL_DATETIME_FORMAT);
          t.end = edate.utc().format(environment.FULL_DATETIME_FORMAT);
        }

        let s = new Date(t.start);
        if (e < s || t.end == environment.DEFAULT_DATETIME_FULL || t.end == environment.DEFAULT_DATETIME_START) {
          t.end = null;
        }

        if(t.Priority == this.Priorities[1])
        {
          t.color = '#8b0000';
          //t.color = '#666666';
        }
        else {
          switch (t.Status) {
            case this.Statuses[0]:
              t.editable = true;
              break;
            case this.Statuses[1]:
              t.color = '#064d80';
              t.editable = true;
              break;
            case this.Statuses[2]:
              t.color = '#378006';
              t.editable = false;
              break;
            case this.Statuses[3]:
              t.color = '#378006';
              t.editable = false;
              break;
          }
        }
      }
      this.calendar.ResourceTaskTimes = resTT;
    this.child.rerenderCalendar(this.calendar);
  }*/
}




// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/full-calendar/full-calendar.component.ts